import moment from 'moment';
import az from 'moment/locale/az';

moment.updateLocale('az_AZ', {
  calendar: {
    lastDay: '[Dünən]',
    sameDay: '[Bugün]',
    nextDay: '[Sabah]',
    lastWeek: '[Keçən]',
    nextWeek: '[Gələn]',
    sameElse: '[Daha öncəki]',
  }
});

const az_AZ = {
  yes: 'Bəli',
  no: 'Xeyr',
  no_thanks: 'Xeyr, çox sağ olun',
  loading: 'Yüklənir...',
  global_error: 'Təəssüf ki, texniki səbəblərə görə sayta giriş mümkün deyil. Daha sonra yenidən cəhd edin.',
  email: 'E-poçt',
  password: 'Şifrə',
  close: 'Bağla',
  favorites: 'Seçilənlər',
  search: 'Axtarış',
  related: 'Bənzərlər',
  tv: 'ТV kanallar',
  movies: 'Filmlər',
  tvseries: 'TV seriallar',
  on_now: 'TV bələdçi',
  cartoons: 'Cizgi filmləri',
  purchases: 'Alınmışlar',
  premiere: 'Premyeralar',
  my_services: {
    my_services: 'Xidmətlərim',
    my_rents: 'Aldıqlarım',
    my_subscriptions: 'Abunəliklərim',
    subscriptions: 'Abunə ol',
    rents: 'İcarə et'
  },
  page: {
    home: 'Ana səhifə',
    epg: 'Efirdə',
    favorites: 'Seçilənlər',
    notifications: 'Xatırlatmalar',
    records: 'Yaddaşa yazdıqlarım',
    purchases: 'Alınmışlar',
    related: 'Bənzərlər',
    search: 'Axtarış',
    collection: 'Kateqoriya'
  },
  error: {
    invalid_credentials: 'İstifadəçi nömrəsi və ya şifrə yanlışdır',
    invalid_credentials_description: '',
    blocked_subscription: 'Hörmətli istifadəçi, hal-hazırda sizin abunəliyiniz aktiv deyil. Xahiş edirik, balansınızı artırasınız.',
    'invalid old password': 'Şifrə yanlışdır',
    'passwords mismatch': 'Şifrələr eynilik təşkil etməlidir',
    'username field empty': 'Zəhmət olmasa e-poçt xanasını doldurasınız',
    'already exist': 'Bu e-poçt ünvanı ilə artıq qeydiyyatdan keçilib. Başqa e-poçt ünvanından istifadə edin və ya mövcud hesaba daxil olun',
    'password field empty': 'Şifrə xanası mütləq doldurulmalıdır',
    'password too short': 'Şifrə ən azı 6 simvoldan ibarət olmalıdır. Şifrə yaradarkən hərf, rəqəm və xüsusi simvollardan istifadə edə bilərsiniz',
    'invalid password reset code': 'Təsdiq kodu yanlışdır',
    'invalid ack': 'Təsdiq kodu yanlışdır',
    'invalid pin': 'PIN kod yanlışdır'
  },
  registration: {
    texts: {
      button: 'Hesab yarat',
      title: 'Qeydiyyatdan keç',
      description: 'Xidmətlərdən istifadə etmək üçün qeydiyyatdan keçməlisiniz.'
    }
  },
  login: {
    login: 'E-poçt',
    login_example: 'name@domain.com',
    lost_your_password: 'Şifrəni unutmusunuz?',
    logout: 'Hesabdan çıx',
    log_in: 'Daxil ol'
  },
  forgot_password: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Şifrəni unutmusunuz?',
    forgot_password: 'Şifrəni unutmusunuz?',
    send: "Göndər",
    recovery_password: "Şifrəni bərpa et",
    empty_field: "Boş xana",
    wrong_email: "Yanlış e-poçt",
    reset_password_success_message: "Sizin e-poçtunuza şifrənin yenilənməsi üçün keçid linki olan məktub göndəriləcək",
    reset_password_error_message: "Məlumatlar yanlışdır",
  },
  profile: {
    movie: {
      bundle: 'Abunəlik',
      min: 'dəq.',
      fav_add: 'Seçilənlərə əlavə et',
      fav_remove: 'Seçilənlərdən sil',
      trailer: 'Treyler',
      youtube_trailer: 'Youtube Тreyler',
      multiscreen: 'Başqa cihazda izlə',
      related: 'Bənzərlər',
      share: 'Paylaş',
      select_screen: 'Ekranı seç'
    },
    tvSeries: {
      bundle: 'Abunəlik',
      min: 'dəq.',
      fav_add: 'Seçilənlərə əlavə et',
      fav_remove: 'Seçilənlərdən sil',
      trailer: 'Treyler',
      multiscreen: 'Başqa ekranda izlə',
      related: 'Bənzərlər',
      share: 'Paylaş',
      select_screen: 'Ekranı seç',
      seasons: 'Mövsüm',
      episodes: 'Epizod',
      season_short: 'M.', //S01E12
      episode_short: 'Ep.', //S01E12
    },
    channel: {
      calendar: {
        before: 'Bundan öncə',
        previously: 'Daha əvvəl',
        now: 'İndi',
        after: 'Sonra',
        hereafter: 'Daha sonra',
        yesterday: 'Dünən',
        yesterday_at: 'Dünən saat',
        today: 'Bu gün',
        today_at: 'Bu gün',
        tomorrow: 'Sabah',
        tomorrow_at: 'Sabah',
        last: 'Müddət'
      },
      epg: 'TV bələdçi',
      bundle: 'Abunəlik',
      min: 'dəq.',
      fav_add: 'Seçilənlərə əlavə et',
      fav_remove: 'Seçilənlərdən çıxar',
      record_add: 'Yaddaşa yaz',
      record_remove: 'Yaddaşdan sil',
      schedule_remove: 'Yazılışı ləğv et',
      multiscreen: 'Başqa ekranda izlə',
      share: 'Paylaş',
      select_screen: 'Ekranı seç'
    },
    subscription: {
      subscription: 'Abunəlik',
      included: 'Tərkib',
      expires: 'Abunəliyin bitmə tarixi',
      bought: 'Alınıb',
      owned: 'Aldıqlarım',
      subscription_period_end: 'Növbəti ödəniş tarixi',
      subscription_period_start: 'Abunəliyin başlama tarixi',
      subscription_states: {
        active: 'Акtivdir',
        trialing: 'Sınaq müddəti',
        unpaid: 'Ödəniş gözlənilir',
        '_': 'Naməlum'
      },
      canceled: 'Ləğv edildi',
      cancel: 'Abunəliyi ləğv et',
      first_payment: 'İlk ödəniş',
      details: 'Ətraflı',
      status: 'Status',
      are_you_sure: 'Əminsiniz?',
      cancel_desc: 'abunəliyi ləğv etmək istəyirsiniz?',
      re_subscribe: 'Siz yalnız hazırki abunə müddəti başa çatdıqdan sonra abunəliyi yenidən aktivləşdirə bilərsiniz',
      yes: 'Bəli',
      no: 'Xeyr'
    },
    packages: {
      included: 'Daxildir',
      expires: 'Abunəliyin bitmə tarixi',
      bought: 'Alınıb',
      owned: 'Aldıqlarım'
    },
    epg_event: {
      remind_me: 'Xatırlat',
      not_remind: 'Xatırlatma',
      record_add: 'Yaddaşa yaz',
      record_remove: 'Yaddaşdan sil',
      schedule_remove: 'Yazılışı ləğv et'
    },
    notification: {
      remind_me: 'Xatırlat',
      not_remind: 'Xatırlatma',
    },
    npvr: {
      record_add: 'Yaddaşa yaz',
      record_remove: 'Yaddaşdan sil',
      schedule_remove: 'Yazılışı ləğv et'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Operator',
      assembly: 'Montaj',
      actor: 'Aktyor',
      director: 'Rejissor',
      scenario: 'Ssenarist',
      composer: 'Bəstəkar',
      presenter: 'Aparıcı',
      music_director: 'Musiqi rejissoru',
      playback_singers: 'İfaçı',
      _: 'Digər'
    },
    offers: {
      type: {
        'free': 'Pulsuz',
        'transactional-own': 'Al',
        'transactional-rent': 'İcarə et',
        'subscription': 'Abunə ol',
        'transactional-own-bundle': 'Paketi al',
        'transactional-rent-bundle': 'İcarəyə götür',
        'subscription-bundle': 'Abunə ol',
        '_': 'Digər'
      },
      pay_as_you_go: 'Alış təklifi',
      select_bundle: 'Paket seç',
      or: 'və ya',
      free_trial: 'Pulsuz sınaq müddəti',
      free_trial_description: 'Pulsuz sınaq müddəti bitdikdən sonra sizin hesabınızdan abunə haqqı çıxılacaq',
      unit: {
        hour: 'Saat',
        day: 'Gün',
        week: 'Həftə',
        month: 'Ay',
        year: 'İl',
      }
    }
  },
  player: {
    no_signal: 'Siqnal yoxdur',
    reload: 'Yenidən başlat',
    youtube_connection_error: 'Youtube-la bağlantı xətası'
  },
  more_menu_items: 'Daha çox',
  empty_section: 'Bu bölmə boşdur',
  empty_result: 'Uyğun nəticə tapılmadı',
  epg: {
    no_data: 'Bu müddətə uyğun məlumat yoxdur',
    now: 'İndi',
    today: 'Bu gün'
  },
  npvr: {
    filters: {
      status: 'Statusa görə çeşidlə',
      date: 'Tarixə görə çeşidlə',
      alphabet: 'Ada görə çeşidlə',
      channel: 'Kanala görə çeşidlə'
    },
    status: {
      pending: 'Növbədə',
      scheduled: 'Planlanmış',
      recording: 'Yazılır',
      finished: 'Yazıldı',
      failed: 'Yazılış xətası',
      cancelled: 'İstifadəçi tərəfindən ləğv edildi'
    }
  },
  genres: 'Janrlar',
  messages: {
    pin: {
      title: 'PIN kodu daxil et',
      ok: 'OK',
      cancel: 'Ləğv et'
    },
    notification: {
      title: 'Xatırlatma ',
      on_channel: 'kanalında',
      is_switch_show_right_now: '5 dəqiqə sonra başlayacaq. İndi bağlanmaq istəyirsiz?'
    },
    share_request: {
      title: 'Paylaş ',
      vod: 'video',
      live: 'kanal',
      you_have_received: 'Bildiriş aldınız ',
      sharing_notification: '. Bildirişə baxmaq istəyirsiniz?'
    },
    bookmark: {
      title: 'İzləməyə davam?',
      continue_from: '-dan(dən) davam et',
      start_over: 'Əvvəldən başla'
    }
  },
  settings: {
    settings: 'Ayarlar',
    tabs: {
      login: {
        title: 'İstifadəçi nömrəsi',
        email: 'E-poçt',
        password: 'Şifrə',
        sign_in: 'Daxil ol',
        error: 'İstifadəçi nömrəsi və ya şifrə yanlışdır',
        success: 'Geri dönməyinizə çox şadıq!'
      },
      registration: {
        title: 'Qeydiyyat',
        email: 'E-poçt',
        password: 'Şifrə',
        password2: 'Şifrəni təkrarla',
        first_name: 'Ad',
        last_name: 'Soyad',
        sign_up: 'Daxil ol',
        success: "Qeydiyyata görə təşəkkürlər!",
        need_confirmation: "Sizin e-poçtunuza məktub göndərildi. Hesabınızın aktivasiyası üçün məktubdakı keçidə daxil olun.",
      },
      registration_confirm: {
        success: "Qeydiyyata görə təşəkkür edirik. Siz istifadəçi nömrəniz və şifrənizdən xidmətə qoşulmuş digər cihazlarda da istifadə edə bilərsiniz."
      },
      language: {
        title: 'Dil',
        select_language: 'Dil seçimi:'
      },
      parental_control: {
        title: 'Valideyn nəzarəti',
        description: 'Valideyn nəzarətini aktiv et',
        on: 'Aktivdir',
        off: 'Aktiv deyil'
      },
      change_password: {
        title: 'Şifrəni dəyiş',
        save: 'Yadda saxla',
        old_password: 'Köhnə şifrə',
        new_password: 'Yeni şifrə',
        new_password2: 'Şifrəni təkakla',
        success: 'Şifrə yeniləndi'
      },
      reset_password: {
        title: 'Şifrəni yenilə',
        save: 'Yadda saxla',
        enter_new_password: 'Yeni şifrəni daxil et',
        ack: 'Təsdiq kodu',
        password: 'Yeni şifrə',
        success: 'Şifrə yeniləndi'
      },
    },
  },
  toast: {
    type: {
      record: 'Yaddaşa yazdıqlarım',
      favorite: 'Seçilənlər',
      notification: 'Bildirişlər',
      purchase: 'Alınanlar',
      service: 'Xidmət',
      cookies: 'Cookie fayllar',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'Uğurlu yazılış planlaması',
      record_add_fail: 'Yazılış planlaması uğursuz oldu',
      record_remove_success: 'Uğurlu yazılış ləğvi',
      record_remove_fail: 'Yazılışın ləğvi uğursuz oldu',
      favorite_add_success: 'Uğurla əlavə edildi',
      favorite_add_fail: 'Əlavə edilmədə xəta',
      favorite_remove_success: 'Uğurla silindi',
      favorite_remove_fail: 'Silinmədə xəta',
      notification_add_success: 'Uğurla əlavə edildi',
      notification_add_fail: 'Əlavə edilmədə xəta',
      notification_remove_success: 'Uğurla silindi',
      notification_remove_fail: 'Silinmədə xəta',
      purchase_add_success: 'Əməliyyat uğurla başa çatdı',
      purchase_add_fail: 'Əməliyyatda xəta',
      purchase_remove_success: 'Əməliyyat uğurla başa çatdı',
      purchase_remove_fail: 'Əməliyyatda xəta',
      service_unstable_connection: 'Serverlə bağlantı kəsildi',
      enable_cookies: 'Zəhmət olmasa, cookie faylların dəstəklənməsini aktiv edin',
      disable_adblock: 'AdBlock can affect the functionality of the site. ' +
      'Zəhmət olmasa, Ad block tətbiqinin istisnalar siyahısına (ağ siyahı) əlavə edin.'
    },
  },
};

export default az_AZ;



// WEBPACK FOOTER //
// ./src/locales/dics/az_AZ.js